import { createContext } from 'react';
import type { Dispatch, SetStateAction } from 'react';

export const SetAnchorContext = createContext<Dispatch<SetStateAction<{ anchorEl: HTMLButtonElement, anchorId: string }>>>(null);
